import { render, staticRenderFns } from "./applyAfterSaleService.vue?vue&type=template&id=45881470&scoped=true"
import script from "./applyAfterSaleService.vue?vue&type=script&lang=js"
export * from "./applyAfterSaleService.vue?vue&type=script&lang=js"
import style0 from "./applyAfterSaleService.vue?vue&type=style&index=0&id=45881470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45881470",
  null
  
)

export default component.exports